module.exports = __webpack_public_path__ + "img/fooh.abce4120.jpg";